import classNames from 'classnames';
import React from 'react';
import {TextColor} from './text-modifiers';
import {XRay} from './XRay.jsx';

/**
 * @param {string} text
 * @param {string} [fieldId]
 * @param {TextColor} textColor
 */
export function Headline({text, textColor, fieldId = 'headline'}) {
    if (!text) return null;

    return (
        <p className={classNames('content-platform__teaser__title', TextColor[textColor])}>
            {text}
            <XRay fieldId={fieldId} />
        </p>
    );
}
